var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title-bar-container",style:({
    paddingTop: `${_vm.datas.paddingTop}px`,
    paddingBottom: `${_vm.datas.paddingBottom}px`,
    paddingLeft: `${_vm.datas.paddingLeft}px`,
    paddingRight: `${_vm.datas.paddingRight}px`,
    backgroundColor: _vm.datas.bgColor,
  })},[(!_vm.isShow)?_c('div',{class:{ mask: !_vm.isShow }},[_vm._v("已隐藏")]):_vm._e(),_vm._t("name"),_c('div',{staticClass:"title-bar-content"},[_c('div',{staticClass:"title-bar-left"},[(_vm.datas.showLine)?_c('div',[(_vm.datas.iconType === 'line')?_c('div',{staticClass:"title-bar-line"}):(_vm.datas.iconType === '')?_c('div'):_c('div',{staticClass:"title-bar-icon"},[(_vm.datas.image.includes('iconfont'))?_c('i',{class:_vm.datas.image,staticStyle:{"font-size":"20px"}}):_c('van-icon',{attrs:{"color":`var(--theme-primary)`,"name":_vm.datas.image,"size":"20px"}})],1)]):_vm._e(),_c('div',{staticClass:"titlebar-text",style:({
          color: _vm.datas.textColor,
          fontSize: `${_vm.datas.textSize}px`,
          fontWeight: _vm.datas.fontWeight,
        })},[_vm._v(" "+_vm._s(_vm.datas.text || "标题栏")+" ")])])]),_vm._t("deles")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }